<!-- <kendo-chart [title]="productPackageChart.title" [legend]="productPackageChart.legend"
  [seriesDefaults]="productPackageChart.seriesDefaults" [series]="productPackageChart.series"
  [valueAxis]="productPackageChart.valueAxis" [categoryAxis]="productPackageChart.categoryAxis">
</kendo-chart> -->

<kendo-chart>
  <ng-template kendoChartDonutCenterTemplate *ngIf='productPackageChart.donutCenterText.enable'>
    <h3 class="center-value">{{productPackageChart.donutCenterText.value | labelSanitizer}}</h3>
    <span class="center-text">{{productPackageChart.donutCenterText.text | labelSanitizer}}</span>
  </ng-template>
  <kendo-chart-series>
    <kendo-chart-series-item
        type="donut" [data]="productPackageChart.series[0].data"
        categoryField="category" field="value" [border]="productPackageChart.seriesDefaults.border">
        <kendo-chart-series-item-labels
          [color]="labelColor" background="none">
        </kendo-chart-series-item-labels>
    </kendo-chart-series-item>
  </kendo-chart-series>
  <kendo-chart-legend [visible]="productPackageChart.legend.visible" position='bottom'></kendo-chart-legend>
</kendo-chart>